// Utils
import { omitBy } from 'lodash';
import { isNil } from 'lodash/fp';

// Utils
import { getColor, getTitle } from '../../../common/elements/utils/elementPropertyUtils';
import { debouncedFetchElements, FetchElementsResponse } from '../../element/elementService';

// Selectors
import { getElement } from '../../element/selectors/elementSelector';

// Types
import { FetchInlineBoardLinkDetailsResponse } from '../../../common/tiptap/extensions/inlineBoardLink/inlineBoardLinkConstants';
import { GenericReduxThunkAction } from '../../../common/actions/actionTypes';
import { isGuestSelector } from '../../user/currentUserSelector';

const omitNils = (obj: Record<string, any>) => omitBy(obj, isNil);

export const fetchInlineBoardLinkDetails =
    (elementId: string, permissionId?: string): GenericReduxThunkAction =>
    async (dispatch, getState): FetchInlineBoardLinkDetailsResponse => {
        const state = getState();

        // If the current user isn't authenticated, don't bother fetching details
        if (isGuestSelector(state)) return null;

        const element = getElement(state, { elementId });

        if (element) {
            return omitNils({
                title: getTitle(element),
                color: getColor(element),
            });
        }

        const args = {
            elementIds: [elementId],
            permissionIdsOverride: permissionId ? [permissionId] : undefined,
        };

        try {
            // @ts-ignore TS can't infer the type of the thunk dispatch
            const result: FetchElementsResponse = await dispatch(debouncedFetchElements(args));

            const el = result?.elements?.[elementId];

            return omitNils({
                title: getTitle(el),
                color: getColor(el),
            });
        } catch (err) {
            return null;
        }
    };
